import { Loader2 } from 'lucide-react';
import { match } from 'ts-pattern';

import { CustomCircleTickIcon } from '@nesso/ui/icons/custom-circle-tick';

type Props = {
    status: 'completed' | 'in-progress' | 'idle';
};

export function StatusIcon({ status }: Props) {
    return match(status)
        .with('completed', () => <CustomCircleTickIcon className="h-4 w-4 text-secondary" />)
        .with('in-progress', () => (
            <Loader2 className="h-4 w-4 animate-spin text-secondary rounded-full border border-secondary" />
        ))
        .otherwise(() => (
            <div className="h-4 w-4 rounded-full border border-secondary-background" />
        ));
}
